import request from '@/router/axios';
import crypto from "@/util/crypto.js";

const decryptTransform = (data) => {
  //解密
  try {
    // 解密
    const backdata = crypto.decrypt(data);
    return backdata;
  } catch (error) {
    // 处理解密过程中的异常
    const backdata = data;
    return backdata;
  }
};



const encryption = (data) => {
  let text = JSON.stringify(data);
  let key  = crypto.encrypt(text);
  let formData = new FormData();
  formData.append('data', key);
  return formData
}

const encryptParams = (data)=>{
    console.log(crypto.encrypt(JSON.stringify(data)));
    return crypto.encrypt(JSON.stringify(data))
}




//患者随访列表
export const followupList = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/followup/list-page`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


//患者病历列表
export const patientEmrList = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/patient-emr/list-all`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


/**
 * http://192.168.0.117:18000/doc.html#/%E6%82%A3%E8%80%85%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/getCfListDiagnosisInfoListUsingPOST
 * 就诊信息
 **/

export const diagnosisListAll = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/diagnosis-info/list-all`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


//获取预约的颜色
export const getcolors = () => {
  return request({
      url: '/api/ygj-appoint/v1.0/appoint-setting/option/get-appoint-colors',
      method: 'get'
  })
}

/**
 * 患者处置列表
 * http://192.168.0.117:18000/doc.html#/%E6%82%A3%E8%80%85%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/cfListAllUsingPOST
 */

 export const handleList = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/handle/list-all`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


/**
 * 企微-消费概览
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E6%94%B6%E8%B4%B9%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/costViewUsingPOST
 */

 export const patientCostView = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-charge/v1.0/wecom/bill/patient/cost-view`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


/**
 * 企微-待处理账单列表
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E6%94%B6%E8%B4%B9%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/costViewUsingPOST
 */

 export const billPendingList = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-charge/v1.0/wecom/bill/patient/pending-list`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}



/**
 * 企微-已处理账单列表
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E6%94%B6%E8%B4%B9%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/processedListUsingPOST
 */
 export const billProcessedList = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-charge/v1.0/wecom/bill/patient/processed-list`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


/**
 * 企微-收费账单下单据列表
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E6%94%B6%E8%B4%B9%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/processedListUsingPOST
 */

 export const billdocList = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-charge/v1.0/wecom/bill-doc/bill-list`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


/**
 * 企微-患者回访列表
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E6%94%B6%E8%B4%B9%E7%AE%A1%E7%90%86/%E5%B0%98%E9%94%8Btab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/processedListUsingPOST
 */

 export const returnVisitPage = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-chain/v1.0/wecom/return-visit/page`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}


/***
 * 企微-企微绑定客户
 */
export const WeChatBindCustomer = (data) => {
  let formData = encryption(data);
  console.log(formData);
  return request({
    url: `/api/ygj-integration/v1.0/external-contact/wecom/bind-patient`,
    method: 'put',
    data:formData,
    transformResponse: [decryptTransform],
  })
}


/***
 * 企微-取消关联企微客户
 */
export const UnlinkWeChatCustomer = (data) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-integration/v1.0/external-contact/wecom/unbind-patient`,
    method: 'put',
    data:formData,
    transformResponse: [decryptTransform],
  })
}

//根据患者id获取企微线索
export const getMicroCluesByPatientId = (data) => {
  let formData = encryption(data);
  return request({
      url: '/api/ygj-integration/v1.0/external-contact/wecom/get-by-cus',
      method: 'post',
      data:formData,
      transformResponse: [decryptTransform],
  })
}


//企微查询患者详情列表
export const getPatientList = (data) => {
  let formData = encryption(data);
  return request({
      url: `/api/ygj-high-search/v1.0/hs-patient/wecom/detail-page`,
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform]
  })
}

//企微查询患者详情
export const  queryWeChatPatientDetails = (data) => {
  let formData = encryption(data);
  return request({
      url: '/api/ygj-high-search/v1.0/hs-patient/wecom/get-detail',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
  })
}


//企微-患者资料-病历标签

export const  getPatientOralConditions = (data) => {
  let formData = encryption(data);
  return request({
      url: '/api/ygj-patient/v1.0/wecom/patient/emr-label',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
  })
}

//企微-患者咨询列表
export const  patientConsultationList = (data) => {
  let formData = encryption(data);
  return request({
      url: '/api/ygj-patient/v1.0/wecom/patient-consult/list-all',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
  })
}

//获取患者影像列表
export const  getPatientImages = (data) => {
  let formData = encryption(data);
  return request({
      url: '/api/ygj-patient/v1.0/wecom/patient-image/list-all',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
  })
}


//上传文件到微信服务器
export const uploadFileToWeChat = (data) => {
  let formData = encryption(data);
  return request({
      url: '/api/ygj-integration/v1.0/wecom-media/wecom/media-upload',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
  })
}

//患者相关不良事件

export const patientAdverseEvents = (data)=>{
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/adverse-event/patient-events`,
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  })
}

//患者不良事件详情
export const adverseEventsDetail = (data)=>{
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/adverse-event/detail`,
    method: 'POST',
    data: formData,
    transformResponse: [decryptTransform],
  })
}

//企微校验联系人是否有质保卡
export const checkPatientWarrantyCard = (data)=>{
  let formData = encryption(data);
  return request({
    url: `/api/ygj-charge/v1.0/wecom/warranty-card/check`,
    method: 'POST',
    data: formData,
    transformResponse: [decryptTransform],
  })
}

//企微校验联系人是否有口腔健康报告
export const checkPatientOralHealthReport = (data)=>{
  let formData = encryption(data);
  return request({
    url: `/api/ygj-patient/v1.0/wecom/oral-health-report/check`,
    method: 'POST',
    data: formData,
    transformResponse: [decryptTransform],
  })
}

//-查询联系人企微待办任务列表
export const enterpriseMicroTodoList = (params)=>{
  return request({
    url: `/api/ygj-integration/v1.0/wecom-todo-task/list-contact-wecom-todo`,
    method: 'POST',
    params: {
      ...params,
    }
  })
}


//查询我的企微待办任务列表
export const myEnterpriseMicroTodoList = (params)=>{
  return request({
    url: `/api/ygj-integration/v1.0/wecom-todo-task/page-my-wecom-todo`,
    method: 'POST',
    params: {
      ...params,
    }
  })
}

//删除企微待办任务
export const deleteEnterpriseMicroTodo = (data)=>{
  return request({
    url: `/api/ygj-integration/v1.0/wecom-todo-task/delete/`+data.id,
    method: 'DELETE',
    data: data
  })
}

//完成企微待办任务
export const completeEnterpriseMicroTodo = (data)=>{
  return request({
    url: `/api/ygj-integration/v1.0/wecom-todo-task/finish/`+data.id,
    method: 'PUT',
    data: data
  })
}

//新增企微待办任务
export const addEnterpriseMicroTodo = (data)=>{
  return request({
    url: `/api/ygj-integration/v1.0/wecom-todo-task/submit`,
    method: 'POST',
    data: data
  })
}


//企微联系人绑定的患者基础信息
export const BoundPatientBasicInfo = (params)=>{
  return request({
    url: `/api/ygj-patient/v1.0/wecom/patient/base-info`,
    method: 'POST',
    params: params
  })
}



/**
 * 查看列表的手机号码记录日志
 * {
 *  "patientIds": [],
 *  "place": 0
 * 	 查看列表（1、工作台-今日回访 2、工作台-医生随访 3、工作台-咨询师随访 
 *   4、工作台-今日随访 5、营销-回访管理-回访管理 6、营销-回访管理-我的回访 7、营销-咨询管理-网电工作台-我的回访）
 *   8、web端患者查看  9 小程序查看 23 企业微信
 * 
 * }
 */
export const lookPatientPhone = (data) => {
  return request({
      url: `/api/ygj-patient/v1.0/patient/look-phone`,
      method: 'POST',
      data
  })
}
//记录查看蓝莓熊用户手机号
export const lookScrmUserPhone = (data) => {
  return request({
      url: `/api/ygj-scrm-manage/v1.0/user/look-phone`,
      method: 'POST',
      data
  })
}


//企微联系人绑定的患者治疗方案列表

export const getBoundPatientTreatmentPlan = (params) => {
  return request({
    url: `/api/ygj-patient/v1.0/wecom/treatment-plan/list-all`,
    method: 'post',
    params: params
  })
}

/**
 * 创建预约
 * POST /ygj-appoint/v1.0/appoint/submit
 */
export const createAppointment = (data) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/submit`,
    method: "post",
    data,
  });
};


/**
 * 企微患者中心-修改预约
 * PUT /ygj-appoint/v1.0/appoint/submit
 */
export const updateAppointment = (data) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/submit`,
    method: "put",
    data,
  });
};

/**
 * 确认预约
 * GET /ygj-appoint/v1.0/appoint/confirm/{id}
 */
export const confirmAppointmentApi = (id) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/confirm/${id}`,
    method: "get",
  });
};

/**
 * 取消预约
 * PUT /ygj-appoint/v1.0/appoint/cancel
 */
export const cancelAppointment = (data) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/cancel`,
    method: "put",
    data,
  });
};


/**
 * 企微患者中心-预约详情（编辑回填）
 * GET /ygj-appoint/v1.0/appoint/get/{id}
 */
export const getWecomAppointmentDetail = (id) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/get/${id}`,
    method: "get",
  });
};

/**
 * 医生已约时段列表（用于持续时间灰底不可选）
 * 对齐小程序接口：GET /ygj-appoint/v1.0/wx/appoint/list-doctor-appointed-time
 */
export const getDoctorAppointedTime = (params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/wx/appoint/list-doctor-appointed-time`,
    method: "get",
    params,
  });
};

/**
 * 诊所预约项目分组（按就诊类型）
 * 对齐小程序：GET /ygj-appoint/v1.0/appoint-item/clinic/select-list-group
 */
export const getAppointmentItemGroupByClinic = (params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint-item/clinic/select-list-group`,
    method: "get",
    params,
  });
};

/**
 * 当前员工常用预约项目 id 列表
 * 对齐小程序：GET /ygj-high-search/v1.0/hs-appoint/often-use-item-list
 */
export const getOftenUseAppointmentItems = (params = {}) => {
  return request({
    url: `/api/ygj-high-search/v1.0/hs-appoint/often-use-item-list`,
    method: "get",
    params,
  });
};

/**
 * 下拉选择患者与员工关系分类
 * GET /ygj-patient/v1.0/patient/select-emp-relation
 */
export const getPatientSelectEmpRelation = (params) => {
  return request({
    url: "/api/ygj-patient/v1.0/patient/select-emp-relation",
    method: "get",
    params,
  });
};

/**
 * 企微患者选择弹层分页列表
 * POST /ygj-high-search/v1.0/wx-hs-patient/select-list-page
 * @param {Object} data - 请求参数（需加密）
 */
export const getWxHsPatientSelectListPage = (data = {}) => {
  let formData = encryption(data);
  return request({
    url: `/api/ygj-high-search/v1.0/wx-hs-patient/select-list-page`,
    method: "post",
    data: formData,
    transformResponse: [decryptTransform],
  });
};



/**
 * 患者预约记录列表
 * GET /ygj-appoint/v1.0/appoint/patient-appoint-list
 * @param {Object} params - 查询参数
 */
export const getPatientAppointList = (params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/patient-appoint-list`,
    method: "get",
    params,
  });
};


/**
 * 连锁门店渠道来源列表
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E8%BF%9E%E9%94%81%E7%BB%84%E7%BB%87/[%20web%E5%89%8D%E7%AB%AF%20]%20%E8%AF%8A%E6%89%80%E6%9D%A5%E6%BA%90%E6%8E%A5%E5%8F%A3/selectUsingGET
 * @param {Object} params - 查询参数
 */
export const getClinicSourceSelect = (params = {}) => {
  return request({
    url: `/api/ygj-chain/v1.0/clinic-source/select`,
    method: "get",
    params,
  });
};


/**
 * 获取患者处置列表
 * GET /ygj-patient/v1.0/handle-detail/list-invite
 * @param {Object} params - 查询参数
 */
export const getHandleDetailListInvite = (params = {}) => {
  return request({
    url: `/api/ygj-patient/v1.0/handle-detail/list-invite`,
    method: "get",
    params,
  });
};

/**
 * 获取患者随访列表（小程序）
 * http://swaggerdev.ygjkq.com:18000/doc.html#/%E6%82%A3%E8%80%85%E7%AE%A1%E7%90%86/[%20web%E5%89%8D%E7%AB%AF%20]%20%E6%82%A3%E8%80%85%E9%9A%8F%E8%AE%BF%E8%AE%B0%E5%BD%95%E6%8E%A5%E5%8F%A3/listFollowupMiniDataUsingGET
 * @param {Object} params - 查询参数
 */
export const getPatientFollowupListMiniData = (params = {}) => {
  return request({
    url: `/api/ygj-patient/v1.0/followup/list-mini-data`,
    method: "get",
    params,
  });
};


/**
 * 获取医生 咨询师 排班 日程
 * GET /ygj-appoint/v1.0/wx/daily-schedule/appoint-valid
 * @param {Object} params - 查询参数
 */
export const getAppointValid = (params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/wx/daily-schedule/appoint-valid`,
    method: "get",
    params,
  });
};

/**
 * 获取指定员工的排班列表
 * GET /ygj-appoint/v1.0/wx/schedule/list-by-employee
 * @param {Object} params - 查询参数
 */
export const getScheduleListByEmployee = (params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/wx/schedule/list-by-employee`,
    method: "get",
    params,
  });
};

/**
 * 检查患者在指定日期是否存在预约数据
 * GET /ygj-appoint/v1.0/appoint/exists-of-data-by-patient
 * @param {Object} params - 查询参数
 */
export const getExistsOfDataByPatient = (params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/exists-of-data-by-patient`,
    method: "get",
    params,
  });
};

/**
 * 检查员工在指定时间段内是否有重叠预约
 * GET /ygj-high-search/v1.0/hs-appoint/overlap-of-emp
 * @param {Object} params - 查询参数
 */
export const getOverlapOfEmp = (params = {}) => {
  return request({
    url: `/api/ygj-high-search/v1.0/hs-appoint/overlap-of-emp`,
    method: "get",
    params,
  });
};


/**
 * 判断指定日期是否为公休日
 * GET /ygj-chain/v1.0/calendar/is-public-holiday
 * @param {Object} params - 查询参数，应包括日期字段（如 date）
 */
export const getIsPublicHoliday = (params = {}) => {
  return request({
    url: `/api/ygj-chain/v1.0/calendar/is-public-holiday`,
    method: "get",
    params,
  });
};

/**
 * 获取默认就诊类型
 * GET /ygj-appoint/v1.0/appoint/get-default-visitType
 * @param {Object} params - 查询参数
 */
export const getDefaultVisitType = (patientId,params = {}) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/get-default-visitType/${patientId}`,
    method: "get",
    params,
  });
};



//通过来源ID获取来源分类类型
export const getCategoryTypeByIdApi = (secondSourceId) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic-source/get-category-type",
    method: "GET",
    params: { secondSourceId },
  });
};


//获取就诊来源分类类型和一级来源
export const getSourceCategoryAndTopSourceApi = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic-source/select-top-source",  // 请求地址
    method: "GET",  // 请求方法为GET
    params,  // 传入的参数
  });
};


/**
 * 获取就诊类型（业务字典 select-list，uniqNo=5010）
 * GET /blade-system/v1.0/dict-biz/select-list?uniqNo=5010
 */
export const getVisitTypeOptionsApi = (params) => {
  return request({
    url: '/api/blade-system/v1.0/dict-biz/select-list',
    method: 'get',
    params: {
      uniqNo: 5010,
      ...params,
    },
  });
};


/**
 * 企微患者中心-改约（重新预约）
 * POST /ygj-appoint/v1.0/appoint/reschedule
 * @param {Object} data - 改约所需参数
 */
export const rescheduleAppointment = (data) => {
  return request({
    url: `/api/ygj-appoint/v1.0/appoint/reschedule`,
    method: "post",
    data,
  });
};

/**
 * 字典获取改约原因
 * @param {Object} params 传入参数，需包含 uniqNo
 * @returns {Promise}
 */
export const getRescheduleReason = (params) => {
  return request({
    url: '/api/blade-system/v1.0/dict-biz/select-list',
    method: 'get',
    params:{
      uniqNo: 5061,
      ...params,
    },
  });
};

/**
 * 查询患者所有报告列表（常规版本报告）
 * GET /ygj-patient/v1.0/patient-oral-report/list-all
 * @param {Object} params - 查询参数
 */
export const getPatientOralReportListAll = (params = {}) => {
  return request({
    url: '/api/ygj-patient/v1.0/patient-oral-report/list-all',
    method: 'get',
    params,
  });
};

/**
 * 查询患者最近更新的诊疗方案信息（藩后街专属报告，一个患者对应一个报告，无报告ID）
 * GET /ygj-patient/v1.0/treatment-plan/get-latest-update
 * @param {Object} params - 查询参数
 */
export const getTreatmentPlanLatestUpdate = (params = {}) => {
  return request({
    url: '/api/ygj-patient/v1.0/treatment-plan/get-latest-update',
    method: 'get',
    params,
  });
};